import type { TaskEither } from 'fp-ts/lib/TaskEither';
import { fetchTE } from 'utils/request';
import type { ComputeClusters } from 'api/computeClusters/types';

export const postComputeClustersTE = <E = CF.API.ApiError>(
  { userId, body }: { userId: string; body: ComputeClusters },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, ComputeClusters> =>
  fetchTE<ComputeClusters, E>(
    {
      path: `/api/_api/v2/users/${userId}/compute_clusters`,
      method: 'POST',
      body,
    },
    onRejected,
  );
